import { render, staticRenderFns } from "./Cockpit.vue?vue&type=template&id=bbdca652&scoped=true&"
import script from "./Cockpit.vue?vue&type=script&lang=ts&"
export * from "./Cockpit.vue?vue&type=script&lang=ts&"
import style0 from "./Cockpit.vue?vue&type=style&index=0&id=bbdca652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdca652",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VProgressCircular,VRow,VTooltip})
